import { Injectable, Inject, Optional } from "@angular/core";
import { REQUEST } from '@nguniversal/express-engine/tokens';

/**
 * Сервис для работы с адресом страницы напрямую без стейта
 */
@Injectable()
export class QueryService {

  constructor (
    @Optional() @Inject(REQUEST) public request: any,
  ) {}

  isEmbed () {
    let isEmbed = false;
    if (!this.request) {
      const location = document.location;
      isEmbed = !!location.search.match(/embed=true/);
    } else {
      isEmbed = this.request.query.embed === 'true';
    }
    return isEmbed;
  }
}